<template>
  <div class="header-container justify-between flex-row">
    <span class="text_16 pointer" @click="goToPage('/home')">{{ $t('nav.brand') }}</span>
    <div class="flex-row menu-content">
      <div class="menu-item"
        :class="{ active: isActive('/company-introduction') || isActive('/company-history') || isActive('/company-event') }">
        <span class="pointer" @click="goToPage('/company-introduction')">
          {{ $t('nav.company') }}
        </span>
        <div class="submenu">
          <div class="submenu-item" @click="goToPage('/company-introduction')">{{ $t('company.tabs.intro') }}</div>
          <div class="submenu-item" @click="goToPage('/company-history')">{{ $t('company.tabs.history') }}</div>
          <div class="submenu-item" @click="goToPage('/company-event')">{{ $t('company.tabs.event') }}</div>
        </div>
      </div>

      <div class="menu-item"
        :class="{ active: isActive('/business') || isActive('/technology') || isActive('/textile') }">
        <span class="pointer" @click="goToPage('/business')">
          {{ $t('nav.business') }}
        </span>
        <div class="submenu">
          <div class="submenu-item" @click="goToPage('/business')">{{ $t('business.tabs.overview') }}</div>
          <div class="submenu-item" @click="goToPage('/textile')">{{ $t('business.tabs.textile') }}</div>
          <div class="submenu-item" @click="goToPage('/technology')">{{ $t('business.tabs.tech') }}</div>
        </div>
      </div>

      <div class="menu-item" :class="{ active: isActive('/culture-concept') || isActive('/culture-solar') }">
        <span class="pointer" @click="goToPage('/culture-concept')">
          {{ $t('nav.culture') }}
        </span>
        <div class="submenu">
          <div class="submenu-item" @click="goToPage('/culture-concept')">{{ $t('nav.culture') }}</div>
          <div class="submenu-item" @click="goToPage('/culture-solar')">{{ $t('culture.solarTitle') }}</div>
        </div>
      </div>

      <div class="menu-item"
        :class="{ active: isActive('/policy') || isActive('/application') || isActive('/contribution') }">
        <span class="pointer" @click="goToPolicy">
          {{ $t('nav.sustainability') }}
        </span>
        <div class="submenu">
          <div class="submenu-item" @click="goToPage('/policy')">{{ $t('sustainability.tabs.policy') }}</div>
          <div class="submenu-item" @click="goToPage('/application')">{{ $t('sustainability.tabs.application') }}</div>
          <div class="submenu-item" @click="goToPage('/contribution')">{{ $t('sustainability.tabs.contribution') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToPage(path) {
      this.$router.push(path);
    },
    goToPolicy() {
      this.$root.policyIntroTrigger = true;
      this.$router.push('/policy');
    },
    isActive(path) {
      return this.$route.path === path;
    }
  }
};
</script>

<style scoped lang="scss">
.header-container {
  width: 100%;
  height: 90px;
  border-bottom: 4px solid #71151A;
  padding-left: 12.5vw;
  padding-right: 12.86vw;
  display: flex;
  align-items: center;
}


.text_16 {
  display: flex;
  align-items: center;
  color: #71151A;
  font-size: var(--fs-title);
  line-height: var(--lh-tight);
  font-weight: bold;
}

.menu-content {
  color: #71151A;
  font-size: var(--fs-body-sm);
  line-height: var(--lh-tight);
  height: 100%;
  display: flex;
  align-items: center;

  .menu-item {
    position: relative;
    margin-right: 2.81vw;

    &:last-child {
      margin-right: 0;
    }

    >span {
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 1px;
        background-color: #71151A;
        transition: width 0.25s ease;
      }

      &:hover {
        opacity: 0.8;

        &::after {
          width: 140%;
        }
      }
    }

    &.active>span::after {
      width: 140%;
    }

    .submenu {
      position: absolute;
      top: calc(100% + 2px);
      left: 50%;
      transform: translateX(-50%);
      min-width: 160px;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.08);
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
      border-radius: 6px;
      padding: 8px 0;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.18s ease;
      z-index: 20;
    }

    .submenu-item {
      font-size: var(--fs-body-sm);
      line-height: var(--lh-normal);
      padding: 10px 18px;
      white-space: nowrap;
      cursor: pointer;
      transition: background 0.15s ease, color 0.15s ease;
    }

    .submenu-item:hover {
      background: rgba(113, 21, 26, 0.08);
      color: #71151A;
    }

    &:hover .submenu,
    &:focus-within .submenu {
      opacity: 1;
      pointer-events: auto;
    }
  }
}

@media (orientation: portrait) {
  .header-container {
    padding-left: 1vw;
    padding-right: 1vw;
  }
}
</style>
